// @flow

const st = typeof localStorage === 'object' ? localStorage : {};

type Storage = {
  set(key: string, value: any): void,
  get(key: string): ?any,
  remove(key: string): void,
  clear(): void,
  push(key: string, data: any): void,
  unshift(key: string, data: any): void,
  splice(key: string, data: any): void,
};

export const keys = {
  user: '__datasee_user__',
};

const storage: Storage = {
  set(key, value) {
    st[key] = JSON.stringify(value);
  },
  get(key) {
    if (!st[key]) return null;
    const value = st[key];
    try {
      const parsed = JSON.parse(value);
      return parsed;
    } catch (e) {
      return value;
    }
  },
  remove(key) {
    delete st[key];
  },
  clear() {
    if (st.clear) {
      st.clear();
    }
  },
  push(key, data) {
    let value = st[key];
    if (!value) {
      this.set(key, [data]);
      value = st[key];
    }
    const parsed = JSON.parse(value);
    if (parsed.indexOf(data) === -1) {
      parsed.push(data);
      st[key] = JSON.stringify(parsed);
    }
  },
  unshift(key, data) {
    let value = st[key];
    if (!value) {
      this.set(key, [data]);
      value = st[key];
    }
    const parsed = JSON.parse(value);
    if (parsed.length > 9) {
      parsed.length = 9;
    }
    if (parsed.indexOf(data) === -1) {
      parsed.unshift(data);
      st[key] = JSON.stringify(parsed);
    }
  },
  splice(key, data) {
    const value = st[key];
    const parsed = JSON.parse(value);
    parsed.splice(parsed.indexOf(data), 1);
    st[key] = JSON.stringify(parsed);
  },
};

export default storage;



// WEBPACK FOOTER //
// ./src/lib/storage.js